import { IMakeRequest } from '../../utils/make_request';
import { FOfferType } from '../../utils/offer_type';

export const RealtyType: { [key: number]: string } = {
  [FOfferType.FlatNew]: 'flatNew',
  [FOfferType.FlatOld]: 'flatSecondary',
  [FOfferType.House]: 'houseOrPlot',
  [FOfferType.Land]: 'houseOrPlot',
  [FOfferType.Townhouse]: 'townhouse',
  [FOfferType.Room]: 'room',
};

export interface IMortgageMetaResponseSuccess {
  totalItems: number;
  minRate: string | null;
}

export function getMortgageMeta(
  makeRequest: IMakeRequest,
  requestUrl: string,
  amount: number,
  deposit: number,
  termInYear: number,
  offerType: FOfferType,
  regionId?: number,
): Promise<IMortgageMetaResponseSuccess> {
  return Promise.resolve({
    totalItems: 0,
    minRate: null,
  });
}
